import axios from "./axios";
import qs from "qs";

export default {
  fetchLogistics(params) {
    return axios.get("/node/fetchLogistics", {
      params: params,
    });
  },
  addLogistics(data) {
    return axios.post("/node/addLogistics", qs.stringify(data));
  },
  updateLogistics(data) {
    return axios.post("/node/updateLogistics", qs.stringify(data));
  },
  findLogisticsByNo(params) {
    return axios.get("/node/findLogisticsByNo", { params });
  },
  batchAppendReceiveLogisticsImages(data) {
    return axios.post("/node/batchAppendReceiveLogisticsImages", qs.stringify(data));
  },
};
